module.exports = "<my-date-picker\n  [options]=\"options\"\n  [selDate]=\"selDate\"\n  (dateChanged)=\"onDateChanged($event)\">\n</my-date-picker>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/form-snippets/date-picker/date-picker.com.html
// module id = ./src/app/modules/shared/form-snippets/date-picker/date-picker.com.html
// module chunks = main